<div class="tt-anchor-link-item_header">
  <div class="tt-anchor-link-item_header-title">
    {{ link().title }}
  </div>

  <div class="tt-anchor-link-item_header-actions">
    <button
      class="tt-anchor-link-item_header-actions-edit"
      ttButton
      [size]="'icon'"
      [ttTooltip]="'AnchorLink.EditLink' | transloco"
      [variant]="'transparent'"
      (click)="editLinkClicked.emit(link())">
      <mat-icon [icon]="'pencil'" [iconSize]="14" />
    </button>
    <button
      class="tt-anchor-link-item_header-actions-remove"
      ttButton
      [size]="'icon'"
      [ttTooltip]="'AnchorLink.DeleteLink' | transloco"
      [variant]="'transparent'"
      (click)="removeLinkClicked.emit(link())">
      <mat-icon [icon]="'x'" [iconSize]="14" />
    </button>
  </div>
</div>

@if (link().description) {
  <common-rich-text-view class="tt-anchor-link-item_description" [content]="link().description" />
}

<div class="tt-anchor-link-item_action">
  @if (link().toElementType === LinkElementType.External || link().toElementType === LinkElementType.Compendium) {
    <a class="tt-anchor-link-item_url" href="{{ link().toUrl }}" rel="noopener noreferrer" target="_blank">
      <mat-icon class="tt-anchor-link-item_url-icon" [icon]="'square-arrow-out-up-right'" [iconSize]="16" />
      {{ 'OpenInNewTab' | transloco }}
    </a>
  } @else if (link().toUrl) {
    <a class="tt-anchor-link-item_reference" data-testid="anchor-link_linkout" target="_blank" (click)="openGuideline(link().toUrl)">
      @switch (link().toElementType) {
        @case (LinkElementType.Widget) {
          <mat-icon class="tt-anchor-link-item_reference-icon" [icon]="'bookmark'" [iconSize]="10" />
          {{ 'Flowchart.NodeDetailDialog.Links.GoToElement' | transloco }}
          ({{ 'External' | transloco }})
        }
        @case (LinkElementType.FlowchartNode) {
          <mat-icon class="tt-anchor-link-item_reference-icon" [icon]="'git-fork'" [iconSize]="10" />
          {{ 'Flowchart.NodeDetailDialog.Links.GoToFlowchart' | transloco }}
          ({{ 'External' | transloco }})
        }
        @case (LinkElementType.Guideline) {
          <mat-icon class="tt-anchor-link-item_reference-icon" [icon]="'book'" [iconSize]="10" />
          {{ 'Flowchart.NodeDetailDialog.Links.GoToGuideline' | transloco }}
          ({{ 'External' | transloco }})
        }
      }
    </a>
  } @else {
    @switch (link().toElementType) {
      @case (LinkElementType.Widget) {
        <a
          class="tt-anchor-link-item_reference"
          data-testid="anchor-link_linkout"
          target="_blank"
          (click)="scrollToChapter(link().toChapterUniqueId)">
          <mat-icon class="tt-anchor-link-item_reference-icon" [icon]="'bookmark'" [iconSize]="12" />
          {{ 'Flowchart.NodeDetailDialog.Links.GoToElement' | transloco }}
        </a>
      }
      @case (LinkElementType.FlowchartNode) {
        <a
          class="tt-anchor-link-item_reference"
          data-testid="anchor-link_linkout"
          target="_blank"
          (click)="scrollToFlowchart(link().toElementUniqueId, link().toChapterUniqueId)">
          <mat-icon class="tt-anchor-link-item_reference-icon" [icon]="'git-fork'" [iconSize]="12" />
          {{ 'Flowchart.NodeDetailDialog.Links.GoToFlowchart' | transloco }}
        </a>
      }
    }
  }
</div>
